import React from "react";
import { Link } from "react-router-dom";
import MusicShell from "../fanHome/MusicShell";
import { isSignedIn } from "../fanHome/fanHomeApi";
import { ACCENT } from "../artistStudio/shared";
import CaseList from "./CaseList";

// /rights-cases: every case the signed-in person filed (any user) or that was filed against their sounds.
export default function MyRightsCases() {
  return (
    <MusicShell maxWidth="max-w-5xl">
      <h1 className="text-2xl md:text-3xl font-bold text-gray-900">My cases</h1>
      <p className="mt-1 text-gray-600">Copyright notices, counter-notices and ownership disputes you filed, or that were filed about your sounds.</p>
      <div className="mt-5">
        {isSignedIn() ? (
          <CaseList empty="You have no cases." />
        ) : (
          <p className="text-gray-700"><Link to="/login" className="font-semibold underline" style={{ color: ACCENT }}>Log in</Link> to see your cases.</p>
        )}
      </div>
    </MusicShell>
  );
}
